import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AccountingAnalyticSubCategoryListPage" */
	'pages/Invoice/AccountingAnalyticSubCategory/AccountingAnalyticSubCategoryListPage'));

export default [{ component, exact: true, path: '/accounting_analytic_sub_categories' }];